import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors.js';

export const DisclaimerStyles = styled.section`
  background-color: ${Colors.secondary.navy1.standard};

  .disclaimer-content {
    margin: 0 auto;
    padding: 1rem 0;
    width: 90%;

    p {
      color: ${Colors.accent.grey3.standard};
      font-size: 12px;
    }
  }
`;
